import { tabClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { highContrast } from '@Styles/a11y'
import { RADIUS_1, RADIUS_3 } from '@Styles/constants/radius'
import { getRawFocusVisibleStyle } from '@Styles/focus'

export const overridesTabs = (theme: Theme): ComponentsOverrides['MuiTabs'] => ({
  root: {
    minHeight: 0,
  },
  indicator: {
    ...highContrast({ backgroundColor: 'Highlight' }),
    backgroundColor: theme.palette.primary.main,
    borderRadius: RADIUS_1,
    display: 'flex',
    height: rem(4),
    justifyContent: 'center',
    '& > span': {
      borderRadius: RADIUS_3,
      maxWidth: '80%',
      width: '100%',
    },
  },
})

export const overridesTab = (theme: Theme): ComponentsOverrides['MuiTab'] => ({
  root: {
    boxShadow: `inset 0 -${rem(4)} 0 ${theme.customPalette.background.paper}`,
    flexGrow: 1,
    minHeight: 0,
    minWidth: rem(100),
    padding: theme.spacing(1.5, 2), // 12px car il y a la bordure inset de 4px
    textTransform: 'none',
    [`&.${tabClasses.selected}`]: {
      fill: theme.palette.primary.main,
    },
    '&:focus-visible::before': getRawFocusVisibleStyle(theme.palette.primary.main, `${RADIUS_1} ${RADIUS_1} 0 0`, '0'),
    '&:hover': {
      backgroundColor: theme.customPalette.onElements.selected,
      borderRadius: `${RADIUS_1} ${RADIUS_1} 0 0`,
    },
  },
  textColorPrimary: {
    color: theme.palette.text.primary,
  },
})
